import { render, staticRenderFns } from "./LicenseActions.vue?vue&type=template&id=31e5c1ce&lang=pug"
import script from "./LicenseActions.vue?vue&type=script&lang=js"
export * from "./LicenseActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports